module.exports = __webpack_public_path__ + "static/img/img2.11cb1af3.png";